import React, { type JSX } from 'react';
import query from './EkonomiskAnalysBehorigTillRutinerQuery.gql';
import {
  EkonomiskAnalysBehorigTillRutinerQueryVariables as IVariables,
  EkonomiskAnalysBehorigTillRutinerQuery as IData,
} from './_QueryTypes/EkonomiskAnalysBehorigTillRutinerQuery';
import useHandledQuery from '../../../../../../../Components/QueryComponents/HandledQuery/HandledQueryHook';

interface IProps {
  dbname: string;
  children: (result: IChildrenProps) => JSX.Element | null;
}

interface IChildrenProps {
  availableRoutines: number[];
  loading?: boolean;
}

const EkonomiskAnalysBehorigTillRutinerQuery: React.FC<IProps> = (
  props: IProps
) => {
  const queryResult = useHandledQuery<IData, IVariables>(
    query,
    { variables: { dbname: [props.dbname] } },
    { loadingComponent: null }
  );

  if (!queryResult.data) {
    return queryResult.renderComponent;
  }

  if (!queryResult.data || !queryResult.data.me || !queryResult.data.me[0]) {
    return props.children({
      availableRoutines: [],
      loading: true,
    });
  }

  return props.children({
    availableRoutines:
      queryResult.data.me?.[0].allowedroutines?.[0].allowedroutines?.concat(
        queryResult.data.me?.[0]?.allowedroutines?.[0]?.readonlyroutines ?? []
      ) ?? [],
  });
};

export default EkonomiskAnalysBehorigTillRutinerQuery;
